"use strict";

class DomUtils {
    static toggle(...elements) {
        Array.from(elements).forEach(element => {
            let display = element.style.display === "block" ? "none" : "block";
            element.style.display = display;
        })
    }

    static show(...elements) {
        Array.from(elements).forEach(element => element.style.display = "block");
    }

    static hide(...elements) {
        Array.from(elements).forEach(element => element.style.display = "none");
    }

    static attachClickEvent(element, handleClick) {
        element.addEventListener('click', () => handleClick());
    }

    static attachInputEvent(element, handleClick) {
        element.addEventListener('input', () => handleClick());
    }

    static limitInput(element, limitTo) {
        element.addEventListener('input', (element) => {
            let elementValue = element.target.value;

            let elementValueIsNotAtLimit = !elementValue.length <= limitTo;

            if (elementValueIsNotAtLimit) {
                element.target.value = elementValue.substring(0, limitTo);
            }

        });
    }
}

module.exports = DomUtils;
